import { ERole } from "./account";

export interface IDriverWalletInput {
  bank: string;
  account: string;
  balance: string;
}

export interface IUpdateDriverWalletInput {
  bank: string;
  account: string;
}

export interface IUpdateDriverWalletBalance {
  balance: string;
}

export interface IDriverWallet {
  bank: string;
  balance: number;
  account: string;
  id: string;
  driver_id: string;
  driver: {
    first_name: string;
    middle_name: string;
    last_name: string;
    phone: string;
  };
  created_at: string;
  updated_at: string;
}

interface IDriver {
  first_name: string;
  middle_name: string;
  last_name: string;
  image: string;
  phone: string;
}

interface IAdmin {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  registered_by: string;
  role: ERole;
  image: string;
  is_active: boolean;
  is_verified: boolean;
  created_at: string;
  updated_at: string;
}

export interface IDriverWalletHistory {
  id: string;
  wallet_id: string;
  amount: number;
  admin_id: null | string;
  trip_id: string;
  trip: {
    driver_id: string;
    pickup_address: string;
    pickup_longitude: number;
    pickup_latitude: number;
    drop_off_address: string;
    drop_off_longitude: number;
    drop_off_latitude: number;
    distance: number;
    price: number;
    available_seats: number;
    seats_booked: number;
    started_at: string;
    ended_at: string;
    waiting_time: number;
    type: string;
    status: string;
    min_passenger: number;
    reason: null | string;
    canceled_at: null | string;
    canceled_by: null | string;
    destination_arrival_time: string;
    id: string;
    created_at: string;
    updated_at: string;
  };
  admin: null | IAdmin;
  reason: string;
  type: string;
  created_at: string;
  updated_at: string;
}

export interface IDriverWalletDetail extends IDriverWallet {
  driver: IDriver;
  histories: IDriverWalletHistory[];
}

export interface IDriverWalletDetailResponse {
  per_page: number;
  loading: boolean;
  page: number;
  total: number;
  data: IDriverWalletDetail;
}

export const defaultWalletDetail: IDriverWalletDetailResponse = {
  loading: true,
  data: {} as any,
  page: 1,
  per_page: 10,
  total: 0,
};
